import { extend, override } from 'flarum/common/extend';
import Session, { LoginParams } from 'flarum/common/Session';
import app from 'flarum/forum/app';
import { getCookie, removeCookie } from '../common/utils';

export default function setupMall() {
  if (app.data.session.userId) {
    // 已登录论坛，但没登录商城
    if (!getCookie('osa-mall')) {
      setTimeout(() => {
        app.request({
          method: 'POST',
          url: '/mall-api/users/login',
          body: { username: app.session.user?.username() },
        });
      }, 0);
    }
  } else {
    // 未登录
    removeCookie('osa-mall');
  }

  override(Session.prototype, 'login', (login: any, body: LoginParams, ...args) => {
    return login(body, ...args).then((result: any) =>
      app
        .request({
          method: 'POST',
          url: '/mall-api/users/login',
          body: { username: body.identification, password: body.password },
        })
        .then(() => result)
        .catch(() => result)
    );
  });

  extend(Session.prototype, 'logout', (logout) => {
    // 删除商城cookie
    removeCookie('osa-mall');
  });
}
